import { AspectRatio } from "@/components/ui/aspect-ratio";
import { Link } from "@/components/common/Link";
const services = [{
  name: "Roofing Installation",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1645726/img/roofing_installation_protection.png"
}, {
  name: "Waterproofing Solutions",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1645726/img/waterproofing_systems_protection.png"
}, {
  name: "Industrial Maintenance",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1645726/img/industrial_roof_maintenance.png"
}, {
  name: "Thermal Insulation",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1645726/img/thermal_insulation_protection.png"
}, {
  name: "Weatherproofing Seals",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1645726/img/weatherproofing_seal_protection.png"
}, {
  name: "Commercial Repairs",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1645726/img/commercial_roof_repair.png"
}];
export default function UltimateServices() {
  return <section data-section-id="223327" id="our-protection-systems" className="bg-background text-foreground relative py-24 overflow-hidden">
      {}
      <div className="absolute inset-0 bg-[url(https://wpvc-images.s3.us-east-1.amazonaws.com/images/1645726/img/industrial_steel_texture_bg.png)] bg-cover bg-center opacity-5 mix-blend-multiply" aria-hidden="true" />

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10">
        <div className="text-center mb-16">
          <h2 className="font-default text-4xl md:text-5xl lg:text-6xl font-extrabold uppercase tracking-tighter text-primary">
            Our Protection Systems
          </h2>
          <div className="w-24 h-1 bg-ring mx-auto mt-6"></div>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
          {services.map((service, i) => <Link key={i} to="#" data-index={i} className="group block relative overflow-hidden rounded-lg bg-card border border-border shadow-sm transition-all duration-500 hover:shadow-xl hover:bg-muted">
              <AspectRatio ratio={4 / 5}>
                <img src={service.image} alt={service.name} className="object-cover w-full h-full transition-transform duration-700 ease-out group-hover:scale-110 grayscale group-hover:grayscale-0" />
                
                {}
                <div className="absolute inset-0 bg-gradient-to-t from-primary/80 via-primary/20 to-transparent pointer-events-none transition-opacity duration-500" />

                {}
                <div className="absolute inset-x-0 bottom-0 h-2/3 bg-gradient-to-t from-ring/40 via-transparent to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-500 pointer-events-none" />

                {}
                <div className="absolute bottom-0 left-0 right-0 p-6 z-10 flex items-end h-full">
                  <h3 className="font-default font-bold uppercase text-white leading-none tracking-tighter transition-transform duration-500 group-hover:-translate-y-2 !text-2xl">
                    {service.name}
                  </h3>
                </div>
              </AspectRatio>
            </Link>)}
        </div>
      </div>
    </section>;
}